import React, { useEffect, useRef, useState } from 'react';
import './FilterSidebar.css';
import { SearchDrop, SearchDropSelect, SliderComponent } from '../../postProject/postProject';

const FilterSidebar = ({setQuery, Query}) => {
  const [isCooldown, setIsCooldown] = useState(false);
  const [Budget_h, setBudget_h] = useState(null);
  const [Budget_l, setBudget_l] = useState(null);
  const [City, setCity] = useState(null);
  const [skill, setskill] = useState(null);
  const [size, setsize] = useState(null);
  const [sector, setsector] = useState(null);
  const initial = useRef(true)
  const cooldownPeriod = 3000; // Cooldown period in milliseconds (e.g., 5000 ms = 5 seconds)

  useEffect(() => {
      if (initial===true) {
        initial.current = false;
        return;
      }
      else {
        if (isCooldown) {
          console.log('Function is on cooldown');
          return;
        }
        
        setQuery({budget_h:Budget_h,budget_l:Budget_l,location:City,skill:skill,project_size:size,sector_p:sector});
  
        // Set the cooldown state to true
        setIsCooldown(true);
    
        // Reset the cooldown state after the cooldown period
        setTimeout(() => {
          setIsCooldown(false);
  
        }, cooldownPeriod);
      }


  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Budget_h,Budget_l,City,skill,size,sector])

  console.log(City)
  console.log(Query)
  console.log(false)




  return (
    <div className={`w-[33%] p-[5%] h-[30dvh] ${isCooldown?'pointer-events-none':''}`}>
      <div className="filter-title">
        Filter
      </div>
      <div className='w-full'>
        <SearchDrop setFunction={setCity} placeholder={"Choose City"} width={100} />
      </div>
      <div className="filter-title">
          Filter
        </div>
      <div className="w-full">
        <SearchDropSelect setFunction={setskill} width={0} />
      </div>
      <div className="filter-title">
          Filter
        </div>
      <div className='w-full'>
        <SliderComponent setFunction={{setBudget_h,setBudget_l}} width={25} />
      </div>
      <div className="filter-title">
          Filter
        </div>
      <div className='w-full flex flex-row justify-evenly gap-[5%]'>
        <div className={`w-fit text-base border-2 ${size==="L"?'border-gray-600':'border-gray-300'} rounded-2xl px-2 py-1 flex items-center cursor-pointer`} onMouseDown={()=>setsize("L")}> <div className='rounded-full border-2 border-gray-500 w-5 h-5 flex justify-center items-center scale-90'>{size==="L" && <div className='bg-gray-600 rounded-full w-3 h-3'></div>}</div>Large</div>
        <div className={`w-fit text-base border-2 ${size==="M"?'border-gray-600':'border-gray-300'} rounded-2xl px-2 py-1 flex items-center cursor-pointer`} onMouseDown={()=>setsize("M")}> <div className='rounded-full border-2 border-gray-500 w-5 h-5 flex justify-center items-center scale-90'>{size==="M" && <div className='bg-gray-600 rounded-full w-3 h-3'></div>}</div>Medium</div>
        <div className={`w-fit text-base border-2 ${size==="S"?'border-gray-600':'border-gray-300'} rounded-2xl px-2 py-1 flex items-center cursor-pointer`} onMouseDown={()=>setsize("S")}> <div className='rounded-full border-2 border-gray-500 w-5 h-5 flex justify-center items-center scale-90'>{size==="S" && <div className='bg-gray-600 rounded-full w-3 h-3'></div>}</div>Small</div>
      </div>
      {/* <div className="filter-section">
    <label className="filter-label">Budget [In lakhs]</label>
    <div className="budget-inputs">
      <input type="number" className="filter-input budget-input" placeholder="Minimum" />
      <input type="number" className="filter-input budget-input" placeholder="Maximum" />
    </div>
  </div> */}
      <div className="filter-section">
        <div className="filter-label">Top Categories</div>
        <div className="categories">
          <div onMouseDown={()=>setsector("Mechanical")} className={`cursor-pointer whitespace-nowrap border-2 border-gray-400 rounded-xl text-sm p-2 ${sector==='Mechanical'?'border-gray-600':null}`}>Mechanical</div>
          <div onMouseDown={()=>setsector("Machinery")} className={`cursor-pointer whitespace-nowrap border-2 border-gray-400 rounded-xl text-sm p-2 ${sector==='Machinery'?'border-gray-600':null}`}>Machinery</div>
          <div onMouseDown={()=>setsector("Electrical & Electronics")} className={`cursor-pointer whitespace-nowrap border-2 border-gray-400 rounded-xl text-sm p-2 ${sector==='Electrical & Electronics'?'border-gray-600':null}`}>Electrical & Electronics</div>
          <div onMouseDown={()=>setsector("Chemicals")} className={`cursor-pointer whitespace-nowrap border-2 border-gray-400 rounded-xl text-sm p-2 ${sector==='Chemicals'?'border-gray-600':null}`}>Chemicals</div>
          <div onMouseDown={()=>setsector("Automobiles")} className={`cursor-pointer whitespace-nowrap border-2 border-gray-400 rounded-xl text-sm p-2 ${sector==='Automobiles'?'border-gray-600':null}`}>Automobiles</div>
          <div onMouseDown={()=>setsector("Metallurgy")} className={`cursor-pointer whitespace-nowrap border-2 border-gray-400 rounded-xl text-sm p-2 ${sector==='Metallurgy'?'border-gray-600':null}`}>Metallurgy</div>
          <div onMouseDown={()=>setsector("Biomedical")} className={`cursor-pointer whitespace-nowrap border-2 border-gray-400 rounded-xl text-sm p-2 ${sector==='Biomedical'?'border-gray-600':null}`}>Biomedical</div>
          <div onMouseDown={()=>setsector("Services to Industries")} className={`cursor-pointer whitespace-nowrap border-2 border-gray-400 rounded-xl text-sm p-2 ${sector==='Services to Industries'?'border-gray-600':null}`}>Services to Industries</div>
        </div>
      </div>
    </div>

  );
};

export default FilterSidebar;



